module.exports = __webpack_public_path__ + "static/fonts/NeoSansPro-Bold.e7e1758.eot";